import {
  SUPPORTING_DOC_DELETE_REQUEST,
  SUPPORTING_DOC_DELETE_SUCCESS,
  SUPPORTING_DOC_DELETE_FAILURE,
  SUPPORTING_DOC_ADDED,
  NO_FORM_DOC_DELETE_SUCCESS,
  GET_COLLECTABLE_SUPPORTING_DOCS_PDF_REQUEST,
  GET_COLLECTABLE_SUPPORTING_DOCS_PDF_SUCCESS,
  GET_COLLECTABLE_SUPPORTING_DOCS_PDF_FAILURE,
  GET_COLLECTABLE_SUPPORTING_DOCS_PDF_CLEAR,
} from 'actions';

// eslint-disable-next-line default-param-last
function supportingDocuments(state = {
  supportingDocs: [],
  isDeletingSupportingDocId: null,
  deletedNoFormDoc: undefined,
  isFetchingCollectablePdf: false
}, action) {
  switch (action.type) {
    case SUPPORTING_DOC_DELETE_REQUEST:
      return {
        ...state,
        isDeletingSupportingDocId: action.isDeletingSupportingDocId,
      };
    case SUPPORTING_DOC_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingSupportingDocId: null,
        deletedNoFormDoc: state.supportingDocs && state.supportingDocs.filter(doc => doc.id === action.isDeletingSupportingDocId && doc.isNoFormDoc === true).length === 1
          ? action.isDeletingSupportingDocId
          : undefined,
        supportingDocs: state.supportingDocs ? state.supportingDocs.filter(doc => doc.id !== action.isDeletingSupportingDocId) : state.supportingDocs
      };
    case SUPPORTING_DOC_DELETE_FAILURE:
      return {
        ...state,
        isDeletingSupportingDocId: action.isDeletingSupportingDocId
      };
    case SUPPORTING_DOC_ADDED:
      return {
        ...state,
        supportingDocs: action.newSupportingDoc ? state.supportingDocs.concat(action.newSupportingDoc) : state.supportingDocs
      };
    case NO_FORM_DOC_DELETE_SUCCESS:
      return {
        ...state,
        deletedNoFormDoc: action.deletedNoFormDoc
      };
    case GET_COLLECTABLE_SUPPORTING_DOCS_PDF_REQUEST:
      return {
        ...state,
        isFetchingCollectablePdf: action.isFetchingCollectablePdf,
        collectableSupportingDocPdfData: null,
        downloadRequestCollectableSupportingDocType: action.downloadRequestCollectableSupportingDocType
      };
    case GET_COLLECTABLE_SUPPORTING_DOCS_PDF_SUCCESS:
      return {
        ...state,
        isFetchingCollectablePdf: action.isFetchingCollectablePdf,
        collectableSupportingDocPdfData: action.collectableSupportingDocPdfData,
        downloadRequestCollectableSupportingDocType: action.downloadRequestCollectableSupportingDocType
      };
    case GET_COLLECTABLE_SUPPORTING_DOCS_PDF_FAILURE:
      return {
        ...state,
        isFetchingCollectablePdf: action.isFetchingCollectablePdf,
        collectableSupportingDocPdfData: null,
        downloadRequestCollectableSupportingDocType: action.downloadRequestCollectableSupportingDocType
      };
    case GET_COLLECTABLE_SUPPORTING_DOCS_PDF_CLEAR:
      if (state.collectableSupportingDocPdfData) {
        URL.revokeObjectURL(state.collectableSupportingDocPdfData);
      }
      return {
        ...state,
        collectableSupportingDocPdfData: null,
      };
    default:
      return state;
  }
}

export default supportingDocuments;
